import React from 'react';

export function ToolsBySJILogo({ className = '', style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 240 40" 
      className={className} 
      style={{ height: '34px', width: 'auto', display: 'inline-block', ...style }}
    >
      <defs>
        <linearGradient id="nav-grad1" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#38bdf8" />
          <stop offset="60%" stopColor="#6366f1" />
          <stop offset="100%" stopColor="#4f46e5" />
        </linearGradient>
        <linearGradient id="nav-grad2" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ec4899" />
          <stop offset="100%" stopColor="#8b5cf6" />
        </linearGradient>
        <linearGradient id="nav-bg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#0f172a" />
          <stop offset="100%" stopColor="#020617" />
        </linearGradient>
      </defs>
      
      {/* Modern Brand Mark */}
      <g transform="translate(4, 4)">
        <rect x="0" y="0" width="32" height="32" rx="8" fill="url(#nav-bg)" stroke="#334155" strokeWidth="1.2" />
        <rect x="1" y="1" width="30" height="30" rx="7" fill="url(#nav-grad1)" opacity="0.12" />
        
        {/* T-bar and dynamic facets */}
        <path d="M6.5 7.5 H25.5 C26.33 7.5 27 8.17 27 9 C27 9.83 26.33 10.5 25.5 10.5 H6.5 C5.67 10.5 5 9.83 5 9 C5 8.17 5.67 7.5 6.5 7.5 Z" fill="url(#nav-grad1)" />
        <path d="M13.5 10.5 H17.5 V23.5 C17.5 24.88 16.38 26 15 26 C14.17 26 13.5 25.33 13.5 24.5 V10.5 Z" fill="url(#nav-grad1)" />
        <path d="M17.5 11.5 L23.5 17.5 C24.1 18.1 24.1 19.1 23.5 19.7 L19 24.2 C18.2 25 17.5 24.5 17.5 23.5 V11.5 Z" fill="url(#nav-grad2)" opacity="0.95" />
        <circle cx="21" cy="9" r="1.2" fill="#ffffff" />
      </g>
      
      {/* Typography: "Tools by SJI" */}
      <text x="48" y="27" fontFamily="Inter, system-ui, -apple-system, sans-serif" fontWeight="800" fontSize="22" fill="currentColor" letterSpacing="-0.5">
        Tools <tspan fontWeight="400" fill="#94A3B8">by</tspan> SJI
      </text>
    </svg>
  );
}

export default ToolsBySJILogo;
